import { IoEllipsisHorizontalOutline, IoFilter } from "react-icons/io5";
import ButtonIcon from "./ButtonIcon";
import TableSettings from "./TableSettings";

const TableControls = ({ onFilter, settings }) => {
  return (
    <div className="flex justify-start mt-3 md:mt-0">
      <ButtonIcon
        title="Filter"
        className="button text-gray-400 border mr-2"
        icon={<IoFilter className="mr-2" />}
        onClick={() => onFilter()}
      />
      {settings && (
        <div className="flex items-center rounded-lg text-gray-400 border ml-2">
          <TableSettings
            title={<IoEllipsisHorizontalOutline />}
            items={settings}
          />
        </div>
      )}
    </div>
  );
};

export default TableControls;
